import { Validation, Messages } from 'utils/forms/validations';
/**
 * Validates the MFA code form values.
 * @param values - The form values to validate.
 * @returns An object containing any validation errors.
 */
export const validate = (values) => {
    const errors = {};
    let formHasErrors = false;
    // Validate numeric-only code
    let validationResult = Validation.number(values.code);
    if (validationResult) {
        errors.code = validationResult;
        formHasErrors = true;
    }
    // Validate exact length of 6 characters
    validationResult = Validation.minMax(values.code, true, 6, 6, 'Code');
    if (validationResult) {
        errors.code = validationResult;
        formHasErrors = true;
    }
    if (formHasErrors) {
        errors._error = Messages.FILL_IN_ALL;
    }
    return errors;
};
